var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{staticClass:"mb-0 justify-space-between pl-3"},[_c('v-list-item-avatar',[_c('v-img',{attrs:{"src":require("@/assets/shield.png"),"height":"40","width":"40","contain":""}})],1),_c('v-list-item-content',{staticClass:"pl-2"},[_c('v-img',{attrs:{"src":_vm.logoSrc,"height":"40","width":"340","contain":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }